/**
 * UI constants exported so CSS and TS cannot drift (doc 08 §5.3).
 * Breakpoint inventory: 1180/980/920/820/760/720/680/560/440 (doc 08 §4).
 */
export const BREAKPOINTS = {
    contextRail: 1180, // context rail hides below this
    layoutLg: 980,
    bp920: 920,
    bp820: 820,
    bp760: 760,
    bp720: 720,
    bp680: 680,
    phone: 560, // major phone shift
    bp440: 440,
};
/** Gate viewports for the visual-fidelity pass (PLAN §9.2 / doc 12 §6.4). */
export const GATE_VIEWPORTS = [1180, 980, 560];
/** z-index ladder (doc 08 §5.3). */
export const Z = {
    base: 0,
    sticky: 10,
    navRail: 20,
    topBar: 30,
    bottomNav: 35,
    drawer: 40,
    drawerScrim: 39,
    popover: 50,
    modal: 60,
    modalScrim: 59,
    toast: 70,
    commandPalette: 80,
};
export const THEME_STORAGE_KEY = "hillman-theme";
export const NAV_STORAGE_KEY = "hillman-nav";
//# sourceMappingURL=ui.js.map